import React from 'react';
import ToggleCell from '@/components/table/ToggleCell';
import { isChecked } from '@/utils/resultsHelper';

const FormObjectToggleCell = ({
  canEdit,
  field,
  item,
  onChange,
}) => (
  <ToggleCell
    className={`aridhia-form-object-toggle-cell-${field.type}`}
    collapsing
    checked={isChecked(item[field.name])}
    disabled={!canEdit}
    onClick={() => onChange(field.name, !isChecked(item[field.name]))}
  />
);

export default FormObjectToggleCell;
